import {createAction, props} from '@ngrx/store';
import {ProductEntity} from '../../entities/product.entity';

export const ProductActionTypes = {
    GetProducts: createAction(
        '[Product] Get Products',
        props<{Payload: ProductEntity[]}>()
    ),
}
